!function(){"use strict";function DcyTranslate(dcyService){return function(labelId,interpolateParams,language){return dcyService.getTranslation(labelId.trim(),interpolateParams,language)}}DcyTranslate.$inject=["dcyService"],angular.module("dcyApp.filters").filter("dcyTranslate",DcyTranslate)}();
//# sourceMappingURL=translate.filter.js.map
;
